module.exports.connect = {
	url: "https://api.camping-echapee-verte.camp/"
}
